import { CrudStoreItemPartner360 } from 'legacy/lut/classes/models/partner360/CrudStoreItemPartner360'

import { CrudStore } from 'core/types/crudStore'

interface IToggleScopeValue {
  entryId: number
  outOfScope: number
}
export const toggleScopeValue = async ({ outOfScope, entryId }: IToggleScopeValue) => {
  const crud = CrudStore.get(CrudStoreItemPartner360.PartnerBasicInfo)

  return crud.update(
    {
      formId: '621',
      code: 'JBPBasicInformation',
    },
    [{ EntryId: entryId, OutOfScope: outOfScope }]
  )
}
